import React, {useState} from "react";
import TextField from "@material-ui/core/TextField";
import {DatePicker, LocalizationProvider} from "@material-ui/pickers";
import {MuiThemeProvider} from "@material-ui/core/styles";
import ruLocale from "date-fns/locale/ru";
import DateFnsUtils from "@date-io/date-fns";
import {materialTheme} from "./styles";
import {useField, useFormikContext} from "formik";


const initProps = {
    mask: "__.__.____",
    okText: "Применить",
    cancelText: "Закрыть",
};


const DatePickerComponent = (props) => {
    const finalProps = {...initProps, ...props};

    const {setFieldValue, setFieldError} = useFormikContext();
    const [field] = useField(props);


    return (
        <MuiThemeProvider theme={materialTheme}>
            <LocalizationProvider dateAdapter={DateFnsUtils} utils={DateFnsUtils} locale={ruLocale}>
                <DatePicker
                    {...finalProps}
                    {...field}
                    clearable
                    placeholder={" "}
                    onError={(reason, value) => {
                        if (value === null) {
                            setFieldError(field.name, `Обязательно для заполнения`);
                            return
                        }
                        if (reason === "invalidDate") {
                            setFieldError(field.name, `Некорректная дата`);
                            return
                        }
                        if (reason === "maxDate") {
                            setFieldError(field.name, `Слишком большая дата`);
                            return
                        }
                        if (reason === "minDate") {
                            setFieldError(field.name, `Дата не может быть раньше текущей`);
                            return
                        }


                        setFieldError(field.name, undefined);
                    }}
                    onChange={(date) => {
                        setFieldValue(field.name, date, false);
                        setFieldError(field.name, "");
                        field.value = date;
                        if (finalProps.hasOwnProperty('onCustomChange')) {
                            finalProps.onCustomChange(field);
                        }
                    }}
                    renderInput={(props) => {


                        return <TextField  {...props}
                                           {...props.inputProps}
                                           size={"small"}
                                           color="secondary"
                                           label={props.label}
                                           className={"me-1 mb-1 w-100"}
                                           variant="outlined"
                                           name={field.name}
                                            autoComplete="off"
                                           inputProps={{
                                               placeholder: "дд.мм.гггг",
                                           }}
                                           error={Boolean(finalProps.helperText)}
                                           helperText={finalProps.helperText}
                        />
                    }}
                />


            </LocalizationProvider>

        </MuiThemeProvider>


    );
}

export default DatePickerComponent